/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState, useContext } from "react";
import {
  getSelectedState,
  Grid,
  GridColumn as Column
} from "@progress/kendo-react-grid";
import { getter, process } from "@progress/kendo-data-query";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  Combobox,
  DatePicker,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea
} from "@repo/ui";
import { useGetCashCenters, useGetInRouteTeam } from "utils/apis/lookups.api";
import {
  useCreateSplitRouteRequest,
  useGetSplitRouteJobs
} from "utils/apis/split-route.api";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { formatDate } from "date-fns";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, type UseFormReturn } from "react-hook-form";
import { PREV_5_DAY_DATE, PREV_DAY_DATE } from "utils/constant";
import { getLink } from "utils/helper";
import { UserContext } from "utils/reducers/user";

const initialDataState = { sort: [{ field: "code", dir: "asc" }] };

const handoverReasons = [
  {
    value: "Route Management",
    label: "Route Management"
  },
  {
    value: "Priority Service",
    label: "Priority Service"
  },
  {
    value: "Adhoc Request",
    label: "Adhoc Request"
  }
];

const formSchema = z.object({
  splitRouteMethod: z.string().min(1, { message: "Route Method is required." }),
  fieldTeamCashCenterId: z
    .string()
    .min(1, { message: "Field Team Cash Center is required." }),
  fieldTeamRouteNo: z
    .string()
    .min(1, { message: "Field Team Route is required." }),
  operationDate: z.date({
    required_error: "Operation date is required."
  }),
  fieldOperationDate: z.date({
    required_error: "Operation date is required."
  }),
  splitReason: z.string().optional(),
  shift: z.string().optional(),
  remarks: z.string().optional()
});

function CreateSplitRoute() {
  const currentDate = new Date();
  const { CashCenterId } = useContext(UserContext);

  const [dataState, setDataState] = useState<any>(initialDataState);
  const [dataState2, setDataState2] = useState<any>(initialDataState);
  const CONSIGNMENT_DATA_ITEM_KEY = "id";
  const DATA_ITEM_KEY = "id";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);
  const consignmentIdGetter = getter(CONSIGNMENT_DATA_ITEM_KEY);

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      splitRouteMethod: "Sending",
      fieldTeamCashCenterId: "",
      operationDate: new Date(),
      fieldOperationDate: new Date(),
      fieldTeamRouteNo: "",
      shift: "morning",
      splitReason: "",
      remarks: ""
    }
  });

  const operationDate = form.watch("operationDate");
  const fieldOperationDate = form.watch("fieldOperationDate");
  const methodType = form.watch("splitRouteMethod");

  const [services, setServices] = useState([]);

  const [isConfirmSplitRoute, setIsConfirmSplitRoute] = useState(false);
  const [selectedState, setSelectedState] = useState<any>({});
  const [selectedConsignmentState, setSelectedConsignmentState] = useState<any>(
    {}
  );
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [selectedConsignmentRequests, setSelectedConsignmentRequests] =
    useState([]);

  const { data: cashCenters } = useGetCashCenters();

  const { data: fieldTeamRouteTeams } = useGetInRouteTeam({
    cashCenterId: form.watch("fieldTeamCashCenterId"),
    shift: "morning",
    operationDate: formatDate(
      fieldOperationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'"
    )
  });

  const { data: routeServicesData, isFetching: loadingRequests } =
    useGetSplitRouteJobs({
      cashCenterId:
        methodType === "Receiving"
          ? form.watch("fieldTeamCashCenterId")
          : CashCenterId,
      shift: "morning",
      operationDate: formatDate(
        (methodType === "Receiving" ? fieldOperationDate : operationDate) ||
          currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'"
      ),
      routeNo: methodType === "Receiving" ? form.watch("fieldTeamRouteNo") : "",
      methodType
    });

  const onSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState,
      dataItemKey: DATA_ITEM_KEY
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key]
    }));

    const selectedJobs = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedJobs.map((req: any) => {
      const service: any = services.find(
        (srv: any) => idGetter(srv) === req.itemKey
      );
      if (service) {
        return { ...service, selected: true };
      }

      return req;
    });

    setSelectedRequests(
      requestIds.flatMap((item: any) =>
        item.containers.map((container: any) => ({
          ...container,
          id: crypto.randomUUID(),
          requestId: item.id
        }))
      )
    );
  };

  const onHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key]
    }));

    const selectedReq = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedReq.map((req: any) => {
      const service: any = services.find(
        (srv: any) => idGetter(srv) === req.itemKey
      );
      if (service) {
        return { ...service, selected: true };
      }

      return req;
    });
    setSelectedRequests(
      requestIds.flatMap((item: any) =>
        item.containers.map((container: any) => ({
          ...container,
          id: crypto.randomUUID(),
          requestId: item.id
        }))
      )
    );
  };

  const onConsignmentSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState: selectedConsignmentState,
      dataItemKey: CONSIGNMENT_DATA_ITEM_KEY
    });

    setSelectedConsignmentState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key]
    }));

    const selectedJobs = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedJobs.map((req: any) => {
      const service: any = selectedRequests.find(
        (srv: any) => consignmentIdGetter(srv) === req.itemKey
      );
      if (service) {
        return { ...service, selected: true };
      }

      return req;
    });

    setSelectedConsignmentRequests(requestIds);
  };

  const onConsignmentHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[consignmentIdGetter(item)] = checked;
    });
    setSelectedConsignmentState(newSelectedState);
    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key]
    }));

    const selectedReq = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedReq.map((req: any) => {
      const service: any = selectedRequests.find(
        (srv: any) => consignmentIdGetter(srv) === req.itemKey
      );
      if (service) {
        return { ...service, selected: true };
      }

      return req;
    });
    setSelectedConsignmentRequests(requestIds);
  };

  const handleIsConfirmModal = (isOpen: boolean) => {
    setIsConfirmSplitRoute(isOpen);
  };

  const onConfirmSplitRouteConsignments = () => {
    handleIsConfirmModal(true);

    setSelectedRequests((prevServices: any) => {
      return prevServices?.map((req: any) => {
        const service: any = services.find(
          (srv: any) => idGetter(srv) === req.itemKey
        );
        if (service) {
          return { ...service, selected: true };
        }

        return req;
      });
    });
  };

  const {
    mutate: createSplitRouteRequest,
    isSuccess: createSuccess,
    isPending: createPending,
    isError: createError
  } = useCreateSplitRouteRequest();

  function ShowOrderIDCell({ dataItem }: any) {
    const { requestId, jobNo } = dataItem;

    return (
      <td>
        {dataItem.serviceType ? (
          <Link
            to={getLink(dataItem?.serviceType)}
            state={{ requestId, jobNo, isReRoute: true }}
          >
            {dataItem.orderId}
          </Link>
        ) : (
          dataItem.orderId
        )}
      </td>
    );
  }
  const onSplitRouteRequestCreated = () => {
    const grouped = selectedConsignmentRequests.reduce(
      (acc: any, item: any) => {
        if (!acc[item.requestId]) {
          acc[item.requestId] = [];
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { requestId, id, selected, ...container } = item;
        acc[requestId].push(container);

        return acc;
      },
      {}
    );

    const updatedMainArray = services
      // remove objects not in flatContainers
      .filter((item: any) => grouped[item.id])
      // update containers
      .map((item: any) => ({
        ...item,
        containers: grouped[item.id]
      }));

    const handoverDto = {
      ...form.getValues(),
      cashCenterId: CashCenterId,
      fieldOperationDate: formatDate(
        fieldOperationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'"
      ),
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'"
      ),
      orders: updatedMainArray
    };
    createSplitRouteRequest(handoverDto);
  };

  useEffect(() => {
    if (routeServicesData) {
      const servicesList = routeServicesData.map((r: any) => ({
        ...r,
        id: `${r?.jobNo}_${r?.orderId}`,
        selected: false
      }));
      setServices(servicesList);
    } else {
      setServices([]);
      setSelectedState({});
    }
  }, [routeServicesData]);

  useEffect(() => {
    if (createSuccess) {
      form.reset();
      setServices([]);
      setSelectedConsignmentRequests([]);
      setSelectedState({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createSuccess, createError]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link to="/split-route">Direct Receiving & Handover</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Create Request</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent className="pt-6">
          <Form {...form}>
            <form
              id="collection-form"
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              onSubmit={form.handleSubmit(onConfirmSplitRouteConsignments)}
              className="gap-4 grid grid-cols-5 items-start"
            >
              <FormSelect
                form={form}
                data={[
                  { name: "Receiving", value: "Receiving" },
                  { name: "Sending", value: "Sending" }
                ]}
                name="splitRouteMethod"
                label="Method"
                placeholder="Select Method"
              />
              {methodType === "Sending" ? (
                <FormField
                  control={form.control}
                  name="operationDate"
                  render={({ field }) => (
                    <FormItem className="space-y-2">
                      <FormLabel>Sending Operation Date</FormLabel>
                      <DatePicker
                        {...field}
                        placeholder="Pick a date"
                        selectedDate={field.value}
                        onSelectDate={field.onChange}
                        disabled={(date) => date < PREV_DAY_DATE}
                      />
                      <FormMessage />
                    </FormItem>
                  )}
                />
              ) : null}
              <FormField
                control={form.control}
                name="fieldOperationDate"
                render={({ field }) => (
                  <FormItem className="space-y-2">
                    <FormLabel>Field Operation Date</FormLabel>
                    <DatePicker
                      {...field}
                      placeholder="Pick a date"
                      selectedDate={field.value}
                      onSelectDate={field.onChange}
                      disabled={(date) => date < PREV_5_DAY_DATE}
                    />
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormCombobox
                form={form}
                data={cashCenters?.map((m: any) => ({
                  value: m.cashCenterId,
                  label: m.name
                }))}
                name="fieldTeamCashCenterId"
                label="Field Team Cash Center"
                placeholder="Select Field Team Cash Center"
              />

              <FormCombobox
                form={form}
                data={fieldTeamRouteTeams?.map((m: any) => ({
                  value: String(m.routeNo),
                  label: `${m.routeNo} (${m.description})`
                }))}
                name="fieldTeamRouteNo"
                label="Field Team Route No."
                placeholder="Select Field Team Route No."
              />
              {methodType === "Receiving" ? (
                <FormField
                  control={form.control}
                  name="operationDate"
                  render={({ field }) => (
                    <FormItem className="space-y-2">
                      <FormLabel>Receiving Operation Date</FormLabel>
                      <DatePicker
                        {...field}
                        placeholder="Pick a date"
                        selectedDate={field.value}
                        onSelectDate={field.onChange}
                        disabled={(date) => date < PREV_DAY_DATE}
                      />
                      <FormMessage />
                    </FormItem>
                  )}
                />
              ) : null}
              <div className="col-span-5 flex justify-end">
                <Button
                  type="submit"
                  variant="secondary"
                  className="max-w-56 w-full"
                >
                  Confirm
                </Button>
              </div>
            </form>
          </Form>

          <div className="border-b my-2 bg-accent" />
          {loadingRequests ? (
            <div className="k-loading-mask">
              <span className="k-loading-text">Loading</span>
              <div className="k-loading-image" />
              <div className="k-loading-color" />
            </div>
          ) : null}

          <Grid
            dataItemKey={DATA_ITEM_KEY}
            selectedField={SELECTED_FIELD}
            data={process(
              services?.map((req: any) => ({
                ...req,
                [SELECTED_FIELD]: selectedState[idGetter(req)]
              })) || [],
              {
                ...dataState,
                skip: 0
              }
            )}
            {...dataState}
            onDataStateChange={(e: any) => {
              setDataState(e.dataState);
            }}
            filterable
            sortable
            selectable={{
              enabled: true,
              drag: true,
              cell: false,
              mode: "multiple"
            }}
            onSelectionChange={onSelectionChange}
            onHeaderSelectionChange={onHeaderSelectionChange}
          >
            <Column
              field={SELECTED_FIELD}
              filterable={false}
              width="40px"
              headerSelectionValue={
                services?.findIndex(
                  (item: any) => !selectedState[idGetter(item)]
                ) === -1
              }
            />
            <Column
              field="jobNo"
              title="Job No"
              className="text-center"
              width="90"
            />
            <Column
              field="orderId"
              width={140}
              title="Order Id"
              cell={ShowOrderIDCell}
            />
            <Column field="customer" title="Customer" width="240" />
            <Column
              field="sourceLocationBarcode"
              title="Source"
              width="340"
              cell={({ dataItem }) => (
                <td>
                  {dataItem?.sourceLocationBarcode}-{dataItem?.sourceLocationId}
                </td>
              )}
            />
            <Column
              field="locationBarcode"
              title="Onward"
              width="340"
              cell={({ dataItem }) => (
                <td>
                  {dataItem?.locationBarcode}-{dataItem?.locationId}
                </td>
              )}
            />

            <Column field="routeNo" title="Route No" width="160" />

            <Column
              field="serviceType"
              title="Service Type"
              className="text-center"
              width="140"
            />
            <Column
              field="jobType"
              title="Job Type"
              className="text-center"
              width="140"
            />
            <Column
              field="status"
              title="Status"
              className="text-center"
              width="140"
            />
            <Column field="remarks" title="Remarks" />
          </Grid>

          <Dialog
            open={isConfirmSplitRoute}
            onOpenChange={handleIsConfirmModal}
          >
            <DialogContent className="max-w-[992px]">
              <DialogHeader>
                <DialogTitle>Confirm Consignments</DialogTitle>
              </DialogHeader>
              <DialogDescription className="max-h-[70vh] overflow-auto">
                <div className="grid grid-cols-3 gap-4 px-1">
                  <div>
                    <label className="font-medium text-sm">Reason</label>
                    <Combobox
                      data={handoverReasons}
                      value={form.watch("splitReason") ?? ""}
                      placeholder="Select Reason"
                      setValue={(val: string) =>
                        form.setValue("splitReason", val)
                      }
                    />
                  </div>

                  <div className="col-span-3">
                    <label className="font-medium text-sm">Remarks</label>
                    <Textarea
                      className="w-full resize-none"
                      value={form.watch("remarks")}
                      onChange={(e) => {
                        form.setValue("remarks", e.target.value);
                      }}
                    />
                  </div>
                </div>

                <Button
                  className="ml-auto flex my-3 w-[180px]"
                  variant="secondary"
                  onClick={onSplitRouteRequestCreated}
                  disabled={
                    !selectedConsignmentRequests?.length || createPending
                  }
                  isLoading={createPending}
                >
                  {methodType === "Receiving"
                    ? "Confirm Receiving"
                    : "Confirm Handover"}
                </Button>
                <Grid
                  dataItemKey={CONSIGNMENT_DATA_ITEM_KEY}
                  selectedField={SELECTED_FIELD}
                  data={process(
                    selectedRequests?.map((req: any) => ({
                      ...req,
                      [SELECTED_FIELD]:
                        selectedConsignmentState[consignmentIdGetter(req)]
                    })) || [],
                    {
                      ...dataState2,
                      skip: 0
                    }
                  )}
                  {...dataState2}
                  onDataStateChange={(e: any) => {
                    setDataState2(e.dataState);
                  }}
                  filterable
                  sortable
                  selectable={{
                    enabled: true,
                    drag: true,
                    cell: false,
                    mode: "multiple"
                  }}
                  onSelectionChange={onConsignmentSelectionChange}
                  onHeaderSelectionChange={onConsignmentHeaderSelectionChange}
                >
                  <Column
                    field={SELECTED_FIELD}
                    filterable={false}
                    width="40px"
                    headerSelectionValue={
                      selectedRequests?.findIndex(
                        (item: any) =>
                          !selectedConsignmentState[consignmentIdGetter(item)]
                      ) === -1
                    }
                  />
                  <Column field="consignmentType" title="Consignment Type" />
                  <Column field="containerType" title="Bag Type" />
                  <Column field="currency" title="Currency" />
                  <Column field="details" title="Denomination" />
                  <Column field="declaredValue" title="Value" />
                  <Column field="count" title="Count" width={70} />
                  <Column field="sealNo" title="Seal No." width={160} />
                  <Column field="remarks" title="Remarks" />
                </Grid>
              </DialogDescription>
            </DialogContent>
          </Dialog>
        </CardContent>
      </Card>
    </Layout>
  );
}

export default CreateSplitRoute;

function FormSelect({
  form,
  name,
  label,
  placeholder,
  data,
  onChange
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder?: string;
  data?: { name: string; value: any }[];
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            value={field.value as any}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {data?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

function FormCombobox({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  ...props
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder: string;
  data?: { label: string; value: any }[];
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Combobox
            value={field.value as any}
            setValue={(e: string) => {
              field.onChange(e);
              onChange?.(e);
            }}
            data={data}
            placeholder={placeholder}
            {...props}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
